import React from 'react';
import { Logo } from '../Logo';

/**
 * The deck always shows the COMPLETE Talab lockup. The product's mark-only
 * variant crops the asset to a square, which reads as a cut-off logo at
 * presentation scale — so every deck surface uses a white plate sized around
 * the full wordmark instead.
 */
export function DeckLogoPlate({
  tone = 'light',
  className = ''
}: {
  tone?: 'light' | 'dark';
  className?: string;
}) {
  return <div className={`inline-flex items-center shrink-0 rounded-lg bg-white px-2.5 ${tone === 'light' ? 'border border-slate-200/80' : ''} ${className}`} data-id="element-1776" data-mp="2j3xrzgphm3hq">
      <Logo size="sm" data-id="element-1777" data-mp="29dmdj086gbwl" />
    </div>;
}